/* eslint-disable sort-keys-fix/sort-keys-fix -- CSS-in-JS pseudo-selector keys use semantic ordering */
// MUI v4 Paper — NS/Tractie component overrides.
// All MUI v4 style classes are declared explicitly (no implicit inheritance on MUI defaults).
// Tokens-foundation: shadows resolven mode-aware via tokens.css cluster 8 (dark = none);
// root bg/fg via mode-flip tokens. Geen fallbacks (per gkaa).

import {
  NS_SHADOW_ELEVATED_1,
  NS_SHADOW_ELEVATED_2,
} from '../../shadow-tokens';

const ELEVATED_2 = { boxShadow: NS_SHADOW_ELEVATED_2 };

export const MuiPaperLightOverrides = {
  elevation0: { boxShadow: 'none' },

  elevation1: {
    boxShadow: NS_SHADOW_ELEVATED_1,
  },

  elevation2: ELEVATED_2,
  elevation3: ELEVATED_2,
  elevation4: ELEVATED_2,
  elevation5: ELEVATED_2,
  elevation6: ELEVATED_2,
  elevation7: ELEVATED_2,
  elevation8: ELEVATED_2,
  elevation9: ELEVATED_2,
  elevation10: ELEVATED_2,
  elevation11: ELEVATED_2,
  elevation12: ELEVATED_2,
  elevation13: ELEVATED_2,
  elevation14: ELEVATED_2,
  elevation15: ELEVATED_2,
  elevation16: ELEVATED_2,
  elevation17: ELEVATED_2,
  elevation18: ELEVATED_2,
  elevation19: ELEVATED_2,
  elevation20: ELEVATED_2,
  elevation21: ELEVATED_2,
  elevation22: ELEVATED_2,
  elevation23: ELEVATED_2,
  elevation24: ELEVATED_2,

  outlined: {
    border: '1px solid var(--ns-color-border-default)',
  },

  rounded: {
    borderRadius: 6,
  },

  root: {
    backgroundColor: 'var(--ns-color-bg-default)',
    color: 'var(--ns-color-fg-default)',
    transition: 'none',
  },
} as const;

// Dark variant: identiek aan Light. bg-default en fg-default zijn mode-aware
// via tokens.css; shadows flippen in tokens.css cluster 8 naar 'none' in dark.
// Geen mode-specifieke override nodig.
export const MuiPaperDarkOverrides = {
  ...MuiPaperLightOverrides,
} as const;
